
import React from 'react';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import SuperAdminOverview from '@/components/superadmin/SuperAdminOverview';
import RevenueBreakdownCard from '@/components/superadmin/dashboard/RevenueBreakdownCard';
import BusinessPlanRevenueCard from '@/components/superadmin/dashboard/BusinessPlanRevenueCard';
import { useSuperAdminDashboard } from '@/hooks/useSuperAdminDashboard';

const SuperAdminDashboard: React.FC = () => {
  const {
    user,
    saasInstances,
    activeInstances,
    suspendedInstances,
    isLoading,
    handleLogout,
    licenseInfo,
    isVerifyingLicense
  } = useSuperAdminDashboard();

  if (isLoading) {
    return (
      <SuperAdminLayout isLoading={true} onLogout={handleLogout} userRole="superadmin" activeTab="dashboard">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </SuperAdminLayout>
    );
  }

  return (
    <SuperAdminLayout 
      isLoading={false} 
      onLogout={handleLogout} 
      userRole={user?.role || 'superadmin'} 
      activeTab="dashboard"
    >
      <div className="container mx-auto px-4 space-y-6">
        <SuperAdminOverview 
          activeInstances={activeInstances?.length || 0}
          suspendedInstances={suspendedInstances?.length || 0}
          totalInstances={saasInstances?.length || 0}
          licenseInfo={licenseInfo}
          isVerifyingLicense={isVerifyingLicense}
        />
        
        {/* Revenue Statistics */}
        <div className="grid grid-cols-1 gap-6">
          <RevenueBreakdownCard />
          <BusinessPlanRevenueCard />
        </div>
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminDashboard;
